import React from 'react';
import { Box, Button } from '@material-ui/core';

import { ModalTitle } from 'components/Modal/Modal';
import { ModalStep } from 'components/Flow/components/ModalStep';
import { StepComponentProps } from 'components/Flow/RenderMachine';
import { Questions } from 'components/Flow/components/Questions';
import { BackButton } from 'components/BackButton/BackButton';

export const WhyNoPPB = ({ send }: StepComponentProps): JSX.Element => (
  <ModalStep
    showHelpCenterLink={false}
    showProgressBar
    actions={
      <div>
        <BackButton onClick={(): unknown => send?.('PREV')} />
      </div>
    }
    header={<Questions />}
    headerStyles={{
      paddingTop: 16,
    }}
  >
    <Box>
      <ModalTitle>Could you tell us why?</ModalTitle>
      <Box mt={3} mb={1}>
        <Button onClick={(): unknown => send('OPTION_FORBIDDEN')} style={{ borderRadius: 4 }}>
          My organization is forbidden by applicable law, government regulation, or policy from
          making a PPB account.
        </Button>
      </Box>
      <Box mb={1}>
        <Button onClick={(): unknown => send('OPTION_NO_CREDS')} style={{ borderRadius: 4 }}>
          I don’t have the credentials for the PPB account associated with my entity
        </Button>
      </Box>
      <Box mb={1}>
        <Button onClick={(): unknown => send('OPTION_NO_DESIRE')} style={{ borderRadius: 4 }}>
          I don’t want a PPB account
        </Button>
      </Box>
    </Box>
  </ModalStep>
);
